import { CleanerTaskSummaryTypes } from "../ActionTypes/CleanerTaskSummaryTypes";

let initialSate = {
  CreateJobDetailsList: [],
  CreateJobDetailsPagination: null,
  TaskSummaryLocationList: [],

};

const CleanerTaskSummaryReducer = (state = initialSate, action) => {
  switch (action.type) {
    case CleanerTaskSummaryTypes.GET_JOB_DETAILS:
      let CreateJobDetailsList_Copy = [];
      CreateJobDetailsList_Copy = [
        ...state.CreateJobDetailsList,
        ...action.payload.data,
      ];
      state = {
        ...state,
        CreateJobDetailsPagination: action.payload,
        CreateJobDetailsList: CreateJobDetailsList_Copy,
      };
      break;

    case CleanerTaskSummaryTypes.CLEAR_JOB_DETAILS:
      state = {
        ...state,
        CreateJobDetailsList: [],
        CreateJobDetailsPagination: null,
      };
      break;

      case CleanerTaskSummaryTypes.GET_LOCATION_LIST:
        state = {
           ...state,
           TaskSummaryLocationList: action.payload.data};
        break;
  
      case CleanerTaskSummaryTypes.CLEAR_LOCATION_LIST:
        state = {
          ...state,
          TaskSummaryLocationList: [],
        };
        break;
  }
  return state;
};

export default CleanerTaskSummaryReducer;
